<div class="modal is-touch is-short" [ngClass]="{'is-open': datePickerModalOpenStatus}">
  <div class="modal__content">
    <div class="modal__body pr2 mrn2" id="calendarPickerModal">
      <div class="container">
        <div class="row no-edge-gutters">
          <div class="col-9 pr4 border-right border-navy-87 touch-calendar__body">
            <div class="touch-calendar__header">
              <button id="btnPrevious" class="btn btn--white" (click)="decrement()" [disabled]="isBtnPreviousDisabled">
                <svg>
                  <use xlink:href="./assets/icons/connect-icons.svg#Left"></use>
                </svg>
              </button>
              <div class="center flex-auto">{{ viewDate | date:'MMMM yyyy' }}</div>
              <button id="btnNext" class="btn btn--white" (click)="increment()" [disabled]="isBtnNextDisabled">
                <svg>
                  <use xlink:href="./assets/icons/connect-icons.svg#Right"></use>
                </svg>
              </button>
            </div>
            <div class="mt1 touch-calendar cal-month-view">
              <mwl-calendar-month-view [viewDate]="viewDate" (dayClicked)="onSave($event.day)" (beforeViewRender)="dayModifier($event)">
              </mwl-calendar-month-view>
            </div>
          </div>
          <div class="col-3 mln1 pr0 flex flex-column justify-content-between">
            <div>
              <div class="h3 bold p2">{{header}}</div>
              <div class="mt5 p2 border-top border-bottom border-navy-87">
                <div class="form-group">
                  <label class="col-auto pr1">Selected Date</label>
                  @if (!showDefaultMonthOnly) {
                    <div>
                      <div class="form-control--static">{{ selectedDate | date:'longDate' }}</div>
                    </div>
                  }
                </div>
              </div>
              @if (futureMedOrdersMode) {
                <div class="px2">
                  <div class="h6 gray-40 pt2 pb1">Select Clinic</div>
                  <div id="calendarClinicModal" class="form-control--touch-select required truncate-wrapper truncate--single"
                    (click)="onSelectClinicClick()">
                    <div id="calendarClinicModalName">
                      {{ selectedClinicItem ? selectedClinicItem.text: 'Select' }}
                    </div>
                  </div>
                </div>
              }
            </div>
            <div class="px2">
              <button class="btn btn--large btn--gray-91 btn--block col-12 py3" (click)="onClear()" id="calendarPickerClearDate">
                {{ futureMedOrdersMode ? 'Clear Options' : 'Clear Date' }}
              </button>
              <button class="mt2 btn btn--true-blue-inverse btn--block col-12 py3" (click)="onCancel($event)" id="calendarPickerCancel">
                Cancel
              </button>
              @if (futureMedOrdersMode) {
                <button id="saveFutureMedOrdersOptions" class="mt2 btn btn--large btn--true-blue btn--block py3"
                  [disabled]="!isSaveFutureMedOrderOptionsEnabled()" (click)="onSaveFutureMedOrderOptions()">
                  Save
                </button>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

@if (futureMedOrdersMode) {
  <div id="calendarPickListClinicList" nc-pageable-pick-list [isModalOpen]="isClinicModalOpen$" [title]="'Clinics'" [items]="clinicList"
    [isSelectedItem]="selectedClinicItem" (itemClicked)="onClinicChanged($event)" (clearSelection)="onClinicsClear()">
  </div>
}